<template>
  <div
    class="modal-content"
    style="width: inherit; height: inherit; margin: 0 auto"
  >
    <div class="modal-header">
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <h4 id="modal_title" class="modal-title">Add New Subscriber</h4>
    </div>
    <div v-if="testdrive.loading && testdrive.addSubscriberErrors.length === 0">
      <loading-component class="hidden-xs"></loading-component>
    </div>
    <div v-else class="modal-body">
      <form>
        <div class="form-group">
          <label for="first_name">First Name:</label>
          <input
            id="first_name"
            ref="first_name"
            v-model="first_name"
            type="text"
            name="first_name"
            class="form-control toggle-required"
            value=""
            required
          />
        </div>
        <div class="form-group">
          <label for="last_name">Last Name:</label>
          <input
            id="last_name"
            ref="last_name"
            v-model="last_name"
            type="text"
            name="last_name"
            class="form-control toggle-required"
            value=""
            required
          />
        </div>
        <div class="form-group">
          <label for="email">Email:</label>
          <input
            id="email"
            ref="email"
            v-model="email"
            type="text"
            name="email"
            class="form-control toggle-required"
            value=""
            required
          />
        </div>
        <div class="form-group">
          <label for="password">Password:</label>
          <input
            id="password"
            ref="password"
            v-model="password"
            type="password"
            name="password"
            class="form-control toggle-required"
            minlength="8"
            required
          />
        </div>
        <div class="form-group">
          <label for="password_confirmation">Confirm Password:</label>
          <input
            id="password_confirmation"
            ref="password_confirmation"
            v-model="password_confirmation"
            type="password"
            name="password_confirmation"
            class="form-control toggle-required"
            minlength="8"
            required
          />
        </div>
        <get-product-select
          @product-selected="productSelected"
        ></get-product-select>
      </form>
      <add-subscriber-errors></add-subscriber-errors>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" @click="addSubscriber">
        Save
      </button>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import store from "../../store/stores";
import AddSubscriberErrors from "./AddSubscriberErrors.vue";
import GetProductSelect from "./GetProductSelect.vue";

export default {
  name: "AddSubscriberForm",
  components: {
    AddSubscriberErrors,
    GetProductSelect,
  },
  store,
  data() {
    return {
      first_name: "",
      last_name: "",
      email: "",
      password: "",
      password_confirmation: "",
      selectedItemId: "",
    };
  },
  computed: {
    ...mapState(["testdrive"]),
  },
  watch: {
    addSubscriberSuccess(newValue) {
      if (newValue === true) {
        this.resetInputs();
      }
    },
  },
  created() {
// eslint-disable-next-line no-unused-vars
    const unsubscribe = store.subscribe((mutation) => {
      if (
        mutation.type === "testdrive/SET_ADD_SUBSCRIBER_SUCCESS" &&
        mutation.payload === true
      ) {
        this.resetInputs();
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  methods: {
    productSelected(itemId) {
      this.selectedItemId = itemId;
    },
    resetInputs() {
      this.first_name = "";
      this.last_name = "";
      this.email = "";
      this.password = "";
      this.password_confirmation = "";
      this.selectedItemId = "";
    },
    addSubscriber() {
      const formFields = this.getFormFields();
      this.$store.dispatch("testdrive/addSubscriber", formFields);
    },
    getFormFields() {
      return {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        password: this.password,
        password_confirmation: this.password_confirmation,
        item_bundle_id: this.selectedItemId,
      };
    },
  },
};
</script>

<style scoped></style>
